import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3e38d6f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex align-center pa-3" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-subtitle-2 font-weight-medium" }, "Értesítések", -1))
const _hoisted_3 = {
  key: 0,
  class: "pa-3"
}
const _hoisted_4 = {
  key: 1,
  class: "text-center pa-8"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-body-2 font-weight-medium mt-2" }, "Nincs értesítés", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-caption text-medium-emphasis" }, " Itt jelennek meg az igényeidhez tartozó események. ", -1))
const _hoisted_7 = { class: "text-caption text-medium-emphasis mt-1" }
const _hoisted_8 = {
  key: 0,
  class: "cv-unread-dot"
}
const _hoisted_9 = {
  key: 0,
  class: "pa-2 text-center"
}

import { ref, watch } from "vue";
import { useRouter } from "vue-router";
import { formatDistanceToNow } from "date-fns";
import { hu } from "date-fns/locale";
import { useAuthStore } from "@/store/AuthStore";
import { useNotifications } from "@/services/useNotifications";
import type { NotificationDTO } from "@/services/NotificationService";
import { notificationTypeIcon } from "@/utils/notificationLabels";
import { notificationLink } from "@/utils/notificationLink";


export default /*#__PURE__*/_defineComponent({
  __name: 'NotificationBell',
  setup(__props) {

const router = useRouter();
const authStore = useAuthStore();
const {
  notifications,
  unreadCount,
  loading,
  loadingMore,
  hasMore,
  connected,
  fetchAll,
  loadMore,
  markAsRead,
  markAllAsRead,
} = useNotifications();

const open = ref(false);

// The stream normally delivers the list on connect. Fetching here covers the case where
// it never opened, without polling for it.
watch(open, (isOpen) => {
  if (isOpen && !connected.value) {
    fetchAll();
  }
});

const relativeTime = (timestamp: string): string =>
  formatDistanceToNow(new Date(timestamp), { addSuffix: true, locale: hu });

async function openNotification(notification: NotificationDTO) {
  await markAsRead(notification.id);
  const target = notificationLink(notification, authStore.isAdmin);
  if (target) {
    open.value = false;
    router.push(target);
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_badge = _resolveComponent("v-badge")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_menu = _resolveComponent("v-menu")!

  return (_openBlock(), _createBlock(_component_v_menu, {
    modelValue: open.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((open).value = $event)),
    "close-on-content-click": false,
    location: "bottom end",
    offset: "8",
    "max-width": "380"
  }, {
    activator: _withCtx(({ props: menuProps }) => [
      _createVNode(_component_v_badge, {
        "model-value": _unref(unreadCount) > 0,
        content: _unref(unreadCount) > 99 ? '99+' : _unref(unreadCount),
        color: "error",
        "offset-x": "6",
        "offset-y": "6"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_btn, _mergeProps(menuProps, {
            icon: "mdi-bell-outline",
            variant: "text",
            "aria-label": `Értesítések${
            _unref(unreadCount) > 0 ? `, ${_unref(unreadCount)} olvasatlan` : ''
          }`
          }), null, 16, ["aria-label"])
        ]),
        _: 2
      }, 1032, ["model-value", "content"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_v_card, {
        width: "380",
        class: "cv-notification-card"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _hoisted_2,
            _createVNode(_component_v_spacer),
            (_unref(unreadCount) > 0)
              ? (_openBlock(), _createBlock(_component_v_btn, {
                  key: 0,
                  variant: "text",
                  size: "small",
                  density: "comfortable",
                  onClick: _unref(markAllAsRead)
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Mind olvasottnak jelöl ")
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_v_divider),
          (_unref(loading))
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_v_skeleton_loader, { type: "list-item-two-line" }),
                _createVNode(_component_v_skeleton_loader, { type: "list-item-two-line" })
              ]))
            : (_unref(notifications).length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(_component_v_icon, {
                    size: "48",
                    color: "grey-lighten-1"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("mdi-bell-outline")
                    ]),
                    _: 1
                  }),
                  _hoisted_5,
                  _hoisted_6
                ]))
              : (_openBlock(), _createBlock(_component_v_list, {
                  key: 2,
                  class: "cv-notification-list py-0",
                  density: "comfortable"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(notifications), (notification) => {
                      return (_openBlock(), _createBlock(_component_v_list_item, {
                        key: notification.id,
                        class: _normalizeClass({ 'cv-notification-unread': !notification.readAt }),
                        onClick: ($event: any) => (openNotification(notification))
                      }, {
                        prepend: _withCtx(() => [
                          _createVNode(_component_v_icon, {
                            icon: _unref(notificationTypeIcon)(notification.type),
                            color: notification.readAt ? 'grey' : 'primary'
                          }, null, 8, ["icon", "color"])
                        ]),
                        append: _withCtx(() => [
                          (!notification.readAt)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_8))
                            : _createCommentVNode("", true)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, { class: "text-body-2 font-weight-medium" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(notification.title), 1)
                            ]),
                            _: 2
                          }, 1024),
                          (notification.body)
                            ? (_openBlock(), _createBlock(_component_v_list_item_subtitle, {
                                key: 0,
                                class: "text-caption"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(notification.body), 1)
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_7, _toDisplayString(relativeTime(notification.createdAt)), 1)
                        ]),
                        _: 2
                      }, 1032, ["class", "onClick"]))
                    }), 128)),
                    (_unref(hasMore))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          _createVNode(_component_v_btn, {
                            variant: "text",
                            size: "small",
                            density: "comfortable",
                            loading: _unref(loadingMore),
                            onClick: _unref(loadMore)
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Korábbiak betöltése ")
                            ]),
                            _: 1
                          }, 8, ["loading", "onClick"])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }))
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})